import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community'
import { NegotiationFieldMeta, NestedLegItem, OrderDetail, UserPreference } from 'api'
import { stopPastePropagation } from 'utils'
import { AgGridContext } from 'view/components/datagrid'
import {
  canEditOrderPreTradeAssignmentStartConsideration,
  canEditOrderPreTradeAssignmentNotional,
  makeCanEditPreTradeAssignmentDetailField,
  canEditOrderPreTradeAssignmentStartConsiderationOverride,
  makeRateFormatter,
  getOrderDetailFromAgGridContext
} from 'view/shared/datagrid'
import { OrderMyEntityCombobox } from 'view/shared/entity'
import {
  PreAssignmentNames,
  makePreAssignmentAccruedInterestColumn,
  makePreAssignmentHaircutColumn,
  makePreAssignmentHaircutTypeColumn,
  makePreAssignmentInitiatorBookColumn,
  makePreAssignmentInitiatorStrategyColumn,
  makePreAssignmentMyEntityColumn,
  makePreAssignmentNotionalColumn,
  makePreAssignmentRateColumn,
  makePreAssignmentStartConsiderationColumn,
  makePreAssignmentStartConsiderationOverrideColumn
} from 'view/shared/preAssignments'

interface StagingPreAssignemntSubGridContext extends AgGridContext {
  userPreference: UserPreference
  orderDetail: OrderDetail
}

export const stagingPreAssignmentSubGridColumnDefs: ColDef[] = [
  makePreAssignmentNotionalColumn({
    editable: canEditOrderPreTradeAssignmentNotional
  }),
  makePreAssignmentMyEntityColumn({
    editable: makeCanEditPreTradeAssignmentDetailField(NegotiationFieldMeta.FUND_ID),
    cellEditorParams: {
      inputComponent: OrderMyEntityCombobox,
      inputParams: (_leg: NestedLegItem, context: StagingPreAssignemntSubGridContext) => ({
        withPortal: true,
        orderDetail: context.orderDetail,
        onPaste: stopPastePropagation
      }),
      defaultField: PreAssignmentNames.FUND_ID_NEGOTIATED,
      isModifiedField: PreAssignmentNames.FUND_ID_MODIFIED,
      updateField: PreAssignmentNames.FUND_ID_MODIFIED,
      validationField: PreAssignmentNames.FUND_ID_VALIDATION
    }
  }),
  makePreAssignmentStartConsiderationColumn({
    editable: canEditOrderPreTradeAssignmentStartConsideration
  }),
  makePreAssignmentStartConsiderationOverrideColumn({
    editable: canEditOrderPreTradeAssignmentStartConsiderationOverride
  }),
  makePreAssignmentRateColumn({
    valueGetter: (params: ValueGetterParams<NestedLegItem>) => {
      const orderDetail = getOrderDetailFromAgGridContext(params)
      return orderDetail?.order?.rate
    },
    valueFormatter: (params: ValueFormatterParams<NestedLegItem>) => {
      const orderDetail = getOrderDetailFromAgGridContext(params)
      return makeRateFormatter()({ ...params, data: orderDetail })
    }
  }),
  makePreAssignmentAccruedInterestColumn(),
  makePreAssignmentInitiatorBookColumn({
    editable: makeCanEditPreTradeAssignmentDetailField(NegotiationFieldMeta.INITIATOR_BOOK)
  }),
  makePreAssignmentInitiatorStrategyColumn({
    editable: makeCanEditPreTradeAssignmentDetailField(NegotiationFieldMeta.INITIATOR_STRATEGY)
  }),
  makePreAssignmentHaircutColumn({
    valueGetter: (params: ValueGetterParams<NestedLegItem>) => {
      const orderDetail = getOrderDetailFromAgGridContext(params)
      return orderDetail?.order?.haircut
    }
  }),
  makePreAssignmentHaircutTypeColumn({
    valueGetter: (params: ValueGetterParams<NestedLegItem>) => {
      const orderDetail = getOrderDetailFromAgGridContext(params)
      return orderDetail?.order?.haircutType
    }
  })
]
